import React from 'react'
// @ts-ignore
import lazyLoad from '@utils/lazyLoad'

const attributeSettingUser = [
  {
    path: '/attributeSetting/users',
    exact: true,
    component: lazyLoad(() =>
      import('@views/ManagementCenter/AttributeSettingUser')
    )
  },
  {
    path: '/attributeSetting/users/new',
    exact: true,
    component: lazyLoad(() =>
      import('@views/ManagementCenter/AttributeSettingUser/AttrDetail')
    ),
    meta: {
      applicationCode: 'f3f9eb1c-5c85-4687-a6ac-3c76045e5b21',
      title: '新建用户属性'
    }
  },
  {
    path: '/attributeSetting/users/:id',
    exact: true,
    component: lazyLoad(() =>
      import('@views/ManagementCenter/AttributeSettingUser/AttrDetail')
    ),
    meta: {
      applicationCode: 'f3f9eb1c-5c85-4687-a6ac-3c76045e5b21',
      title: '用户属性编辑'
    }
  }
]

export default attributeSettingUser
